import { AgentsFactoryActionTypes } from './agentsFactory.types';

export const initialState = {
  loading: false,
  agentAuth: [],
  agentData: null,
  currentAgentId: null,
  error: null,
  improvedText: null,
  loadingImprovedText: false,
};

const agentsFactoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case AgentsFactoryActionTypes.AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_LOADING:
      return {
        ...state,
        loadingImprovedText: action.payload,
      };
    case AgentsFactoryActionTypes.AGENTS_FACTORY_SET_IMPROVED_TEXT:
      return {
        ...state,
        improvedText: action.payload,
      };
    case AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_REQUEST:
      return { ...state, loading: true, error: null };
    case AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_SUCCESS:
      return {
        ...state,
        loading: false,
        agentAuth: action.payload,
        error: null,
      };
    case AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        agentData: action.payload,
        currentAgentId: action.payload ? action.payload.agent_id : null,
        error: null,
      };
    case AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default agentsFactoryReducer;
